<template>
    <v-form ref="form" @submit="submit" v-model="formValid" style="height: 100%">
        <div class="title-config">
            <div class="title">{{ $f.tc('reportViaMail') }}</div>
            <div style="display: flex; align-items: center">
                <div class="btn-outline" style="margin-right: 8px" @click="openChooseTypeReport">
                    <img src="/img/add-blue.svg" style="margin-right: 6px; transform: scale(1.1)">
                    {{ $t('addNew') }}
                </div>
                <choose-type-email-report ref="chooseTypeEmailReport"
                                          @chooseTypeReport="chooseTypeReport" :type-reports="typeReports"></choose-type-email-report>
                <div class="btn-custom" @click="submit">{{ $f.tc('save') }}</div>
            </div>
        </div>
        <div class="fci-scrollbar config-content">
            <div style="text-align: center; font-size: 14px; color: #96ADD0; padding-top: 20px"
                 v-if="itemList.length === 0">{{ $f.tc('noDataAvailable') }}
            </div>
            <div v-else>
                <div v-for="(item, index) in itemList" :key="index" class="config-item">
                    <div style="display: flex; align-items: center">
                        <div style="border-right: 1px dashed #e4edfa; padding: 20px; min-width: 93%">
                            <div class="label">{{ $f.tc('type') }}</div>
                            <v-select
                                v-model="item.type"
                                :items="typeReports"
                                :rules="formRules.required"
                                class="input-custom"
                                item-value="key"
                                item-text="value"
                                :disabled="!!item.id"
                            ></v-select>
                            <div class="label" style="margin-top: 12px">{{ $f.tc('title') }}</div>
                            <v-text-field
                                v-model="item.name"
                                class="input-custom"
                            ></v-text-field>
                            <v-layout align-center style="margin-top: 12px; margin-bottom: 12px;"
                                      v-if="item.type==='call_log_via_email'">
                                <v-flex xs3>
                                    <div class="label">{{ $f.tc('repeat') }}</div>
                                    <div style="width: 150px">
                                        <v-select
                                            v-model="item.repeat"
                                            :items="repeatList"
                                            :rules="[formRules.ruleRequired]"
                                            class="input-custom"
                                        ></v-select>
                                    </div>
                                </v-flex>
                                <v-flex xs3>
                                    <div class="label">{{ $f.tc('from') }}</div>
                                    <DateTimeInput
                                        v-model="item.from_time"
                                        :emit-time-only="true"
                                        type="time"
                                        :rules="[formRules.ruleRequired]"
                                        :use-seconds="true"
                                    ></DateTimeInput>
                                </v-flex>
                                <v-flex xs3>
                                    <div class="label">{{ $f.tc('to') }}</div>
                                    <DateTimeInput
                                        v-model="item.to_time"
                                        :emit-time-only="true"
                                        type="time"
                                        :rules="[formRules.ruleRequired]"
                                        :use-seconds="true"
                                    ></DateTimeInput>
                                </v-flex>
                                <v-flex xs3>
                                    <div class="label">Job ID</div>
                                    <v-text-field
                                        v-model="item.job_id"
                                        class="input-custom"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout align-center style="margin-top: 12px; margin-bottom: 12px;" v-else>
                                <v-flex>
                                    <div class="label">{{ $f.tc('repeat') }}</div>
                                    <div style="width: 250px">
                                        <v-select
                                            v-model="item.repeat"
                                            :items="repeatUploadResultList"
                                            :rules="[formRules.ruleRequired]"
                                            class="input-custom"
                                        ></v-select>
                                    </div>
                                </v-flex>
                            </v-layout>
                            <div class="label">{{ $f.tc('emails') }}</div>
                            <div class="centerY">
                                <v-combobox
                                    ref="NewEmailConfig"
                                    :items="reportList"
                                    class="input-custom mr-6"
                                    v-model="item['new_email']"
                                    spellcheck="false"
                                    hide-details
                                ></v-combobox>
                                <div class="btn-custom" @click="addNewMonitoring(index)">
                                    {{ $f.tc('addNew') }}
                                </div>
                            </div>
                            <!--List emails report-->
                            <div class="monitoring-bar centerY scrollbar-horizontal-thin">
                                <div class="centerY mr-6" style="gap: 6px;flex-wrap: wrap"
                                     v-if="item.emails !=='' && item.emails.split(';').length > 0">
                                    <div class="tag-item centerXY" v-for="monitoringItem in item.emails.split(';')"
                                         :key="monitoringItem">
                                        {{ monitoringItem }}
                                        <img src="/img/debug/close-circle.svg" alt="icon-close"
                                             @click="deleteEmail(index,monitoringItem)" v-if="monitoringItem">
                                    </div>
                                </div>
                            </div>
                            <div style="color: #9AA9BF; font-size: 12px; font-style: italic; padding-top: 12px"
                                 v-if="item.wrong_emails">
                                <img src="/img/notice.svg" alt="icon-notice">
                                {{ item.wrong_emails }}
                            </div>
                        </div>
                        <v-btn icon @click="removeItem(index)">
                            <img src="/img/delete-blue.svg" style="transform: scale(1.2)">
                        </v-btn>
                    </div>
                </div>
            </div>
        </div>
    </v-form>
</template>

<script>
import CampaignService from '@/services/campaign.service'
import BaseConfig from '@/views/Campaign/Form/Step4/BaseConfig'
import DateTimeInput from '@/components/DateTimeInput'
import { mapState } from 'vuex'
import ChooseTypeEmailReport from '@/views/Campaign/Form/Step4/ChooseTypeEmailReport'

export default {
    name: 'EmailReportConfig',
    extends: BaseConfig,
    components: { DateTimeInput, ChooseTypeEmailReport },
    data () {
        return {
            repeatList: [
                { text: 'daily', value: 'daily' },
            ],
            repeatUploadResultList: [
                { text: 'daily', value: 'daily' },
                { text: 'weekly', value: 'weekly' },
                { text: 'per upload', value: 'per_upload' },
            ],
            emptyItem: {
                repeat: '',
                emails: '',
                id: null,
                name: '',
                job_id: '',
                from_time: '00:00:00',
                to_time: '23:59:59',
                type: 'call_log_via_email',
                wrong_emails: '',
                new_email: '',
                showAddEmail: false
            },
            loadFn: CampaignService.getMailReportConfig,
            saveFn: CampaignService.saveMailReportConfig,
            updateFn: CampaignService.updateMailReportConfig,
            deleteFn: CampaignService.deleteMailReportConfig,
            reportList: [],
            typeReports: [
                {
                    'key': 'call_log_via_email',
                    'value': 'Call log via email'
                }
            ],
            showChooseTypeReport: false,
        }
    },
    computed: {
        itemTranslate () {
            return this.$t('mailReport')
        },
        ...mapState({
            campaign: state => state.campaign.campaign
        })
    },
    mounted () {
        this.loadReportList()
        this.loadTypeReport()
    },
    methods: {
        loadTypeReport () {
            if (this.campaign.direction === 'OUTBOUND') {
                this.typeReports.push({
                    'key': 'upload_result_via_email',
                    'value': 'Upload result via email'
                })
            }
        },
        loadReportList () {
            CampaignService.getUserPermissions(this.campaign).then(res => {
                    let assignList = res.data
                    for (const element of assignList) {
                        if (element['permission'] !== 'viewer') {
                            this.reportList.push(element['email'])
                        }
                    }
                }
            )
        },
        addNewMonitoring (index) {
            this.$refs.NewEmailConfig[index].blur()
            this.$nextTick(() => {
                // validate duplicate
                if (this.itemList[index]['emails'].split(';').includes(this.itemList[index]['new_email'])) {
                    this.$appService.toastError(this.$f.tc('formRules.fieldDuplicate'))
                    return
                }
                CampaignService.checkUserCampaign(this.campaign.id, { 'email': this.itemList[index]['new_email'] }).then((res) => {
                    let isValidEmail = res.data['result']
                    if (isValidEmail) {
                        if (this.itemList[index]['emails'] === '') {
                            this.itemList[index]['emails'] = this.itemList[index]['new_email']
                        } else {
                            this.itemList[index]['emails'] = this.itemList[index]['emails'] + ';' + this.itemList[index]['new_email']
                        }
                    } else {
                        if (res.data['msg']) {
                            this.$appService.toastError(res.data['msg'])
                        } else {
                            this.$appService.toastError(this.$f.tc('formRules.fieldNotValid', ['email']))
                        }
                    }
                }).finally(() => {
                    this.itemList[index]['show_add_email'] = false
                })
            })
        },
        deleteEmail (index, email) {
            let arrEmail = this.itemList[index]['emails'].split(';')
            arrEmail = arrEmail.filter(item => item !== email)
            let newArrayEmail = ''
            if (arrEmail.length === 0) {
                this.$appService.toastError(this.$f.tc('emailsNotEmpty'))
                return
            }
            if (arrEmail.length === 1) {
                newArrayEmail = arrEmail[0]
            } else {
                for (let e of arrEmail) {
                    newArrayEmail = newArrayEmail + e + ';'
                }
                newArrayEmail = newArrayEmail.slice(0, -1)
            }
            this.itemList[index]['emails'] = newArrayEmail
        },
        openChooseTypeReport () {
            this.$refs.chooseTypeEmailReport.open()
        },
        chooseTypeReport (type) {
            this.emptyItem['type'] = type
            this.addItem()
        },
        submitValidForm () {
            let invalidConfig = this.itemList.every((v) =>
                v['id'] !== '' && v['emails'] !== ''
            )
            if (invalidConfig) {
                this.saveForm()
            } else {
                this.$appService.toastError(this.$f.tc('itemFieldRequired', { 'item': this.$f.tc('emails') }))
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.config-item {
    width: 100%;
    border-bottom: 1px dashed #e4edfa;
}

.title-config {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 48px;
    padding: 0 20px;
    border-bottom: 1px solid #E4EDFA;
}

.input-custom {
    position: relative;

    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

.label {
    font-family: "open sans semi";
    margin-bottom: 6px;
    font-size: 13px;
}

::v-deep {
    .v-text-field {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .v-text-field__details {
        position: absolute;
        right: 12px;
        top: 10px;
    }

    .v-input__slot {
        margin-bottom: 0 !important;
    }

    .v-select {
        .v-text-field__details {
            right: 30px;
        }

        .v-input__slot {
            padding: 6px 3px 6px 12px;
        }
    }
}

.monitoring-bar {
    padding: 8px 0;
    background: #FFFFFF;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;

    .tag-item {
        padding: 0 6px 0 8px;
        height: 25px;
        line-height: 25px;
        background: #EAEEFF;
        color: #0052CC;
        border-radius: 4px;
        font-size: 13px;
        font-family: "open sans", serif;

        img {
            cursor: pointer;
            width: 18px;
            margin-left: 3px;
        }
    }
}

.btn-add-monitoring {
    padding: 3px 8px;
    cursor: pointer;
    border-radius: 5px;
    justify-content: center;
    color: #818181;
    white-space: nowrap;
    font-family: "open sans", serif;
    font-size: 13px;
    background: #EFEFEF;

    &:hover {
        background: #0052CC;
        color: #FFFFFF;
        transition: 0.3s;

        .icon-add-monitoring {
            background-image: url("/img/debug/add-box_white.svg");
        }
    }
}
</style>
